import { render, staticRenderFns } from "./MailModal.vue?vue&type=template&id=5cccc41e&scoped=true"
import script from "./MailModal.vue?vue&type=script&lang=ts"
export * from "./MailModal.vue?vue&type=script&lang=ts"
import style0 from "./MailModal.vue?vue&type=style&index=0&id=5cccc41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cccc41e",
  null
  
)

export default component.exports